<template>
<div style="overflow: auto;width: 790px;position: relative;">
  <tk-flex column id="aiIdentification" v-if="info && query" class="p-y-30 w-full p-x-24 bg-white order_export">
    <div style="font-size: 22px;color: #060A13;font-weight: bold;text-align: center;width: 100%;">{{ lang==='cn' ? 'AI鉴别报告' : 'AI Appraisal Report' }}</div>
    <div>
      <img v-if="lang === 'cn'" style="position: absolute;right: 40px;top: 0;width: 150px;"
        :src="info.result === 'real' ? require('../../../assets/image/real.svg') : info.result === 'fake' ? require('../../../assets/image/fake.svg') : require('../../../assets/image/default.svg')" alt="">
      <img v-else style="position: absolute;right: 40px;top: 0;width: 150px;"
        :src="info.result === 'real' ? require('../../../assets/image/real_en.svg') : info.result === 'fake' ? require('../../../assets/image/fake_en.svg') : require('../../../assets/image/default_en.svg')" alt="">
    </div>
    <!-- 基本信息 -->
    <tk-flex between style="width: 100%;margin-top: 20px;">
      <div
        class="p-b-20"
        style="font-size: 17px;color:#060A13;font-weight: bold;"
      >{{$t('appUser.userInfo')}}</div>
    </tk-flex>
    <div style="width: 100%;">
      <tk-flex style="width: 100%;">
        <div style="width: 50%">{{ $t('aiIdentification.identifyCategory') + '：' + ( info.category && (lang === 'cn' ? info.category.name : info.category.nameEn) || '-') }}</div>
        <div style="width: 50%">{{ $t('aiIdentification.identifyBrand') + '：' + (info.brand && (lang === 'cn' ? info.brand.name : info.brand.nameEn) || '-') }}</div>
      </tk-flex>
      <tk-flex style="width: 100%;" class="m-t-10">
        <div style="width: 50%">{{ $t('aiIdentification.identifySeries') + '：' + (info.series &&(lang === 'cn' ? info.series.name : info.series.nameEn) || '-') }}</div>
        <div style="width: 50%">{{ $t('aiIdentification.orderNo') + '：' + (info.orderNo || '-') }}</div>
      </tk-flex>
    </div>
    <div style="width: 100%;height: 1px; background: #eeeeee" class="m-y-30"></div>
    <!-- 鉴别信息 -->
    <tk-flex style="width: 100%;" between middle>
      <div
        class="p-b-30"
        style="font-size: 17px;color:#060A13;font-weight: bold;"
      >{{$t('aiIdentification.idenInfo')}}</div>
    </tk-flex>
    <a-table :pagination="false" style="width: 100%;" :columns="columns" :data-source="data">
      <tk-flex column slot="name" slot-scope="data">
        <div style="color: #363B45;font-weight: bold;">{{ lang === 'cn' ? data.identifyPoints.name : data.identifyPoints.nameEn }}<span v-if="!!data.score">（{{ data.score || 0 }}分）</span></div>
        <div class="m-t-10" style="color: #363B45;">{{ data.describe }}</div>
      </tk-flex>
      <tk-image slot="falseArea" v-if="falseArea" style="width: 60px;height:60px;border-radius: 8px;" slot-scope="falseArea" :src="falseArea" />
      <tk-image slot="userImg" style="width: 60px;height:60px;border-radius: 8px;" slot-scope="userImg" :src="userImg" />
    </a-table>
  </tk-flex>
</div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      info: null,
      lang: null,
      query: null,
      columns: [],
      data: [],
      cloudUrl: ''
    }
  },
  async mounted () {
    this.query = this.$route.query.params.split(',')
    this.lang = this.query[1]
    this.cloudUrl = this.query[2] === 'dev' ? 'https://cloud.solestage-dev.mokekeji.com' : 'https://cloud.solestage.mokekeji.com'
    if (this.lang !== localStorage.lang) {
      this.$root.Bus.$emit('switchLanguage', this.query[1])
    }
    localStorage.setItem('lang', this.query[1])
    this.$store.commit('changeLang', this.query[1])
    this.columns = [
      {
        title: this.$t('identifyResult.userImg'),
        key: 'userImg',
        width: 150,
        dataIndex: 'userImg',
        scopedSlots: { customRender: 'userImg' }
      },
      {
        title: this.$t('identifyResult.falseArea'),
        key: 'falseArea',
        width: 150,
        dataIndex: 'falseArea',
        scopedSlots: { customRender: 'falseArea' }
      },
      {
        title: this.$t('identifyResult.identify'),
        dataIndex: 'name',
        key: 'name',
        scopedSlots: { customRender: 'name' }
      }
    ]
    await this.init()
    await this.getIdentify()
  },
  methods: {
    async init () {
      try {
        let { data: res } = await axios.get(`${this.cloudUrl}/classes/authenticationOrder/${this.query[0]}`, {
          params: {
            include: 'user,category,series,brand,appraiser'
          }
        })
        this.info = res
      } catch (e) {
        console.log(e, '出错了')
      }
    },
    async getIdentify () {
      let { data: res } = await axios.get(`${this.cloudUrl}/classes/identifyResult`, {
        params: {
          order: '-createdAt',
          limit: 1000,
          include: 'identifyPoints,authenticationOrder',
          where: {
            authenticationOrder: this.query[0]
          }
        }
      })
      this.data = res.results.map((s, i) => {
        return {
          name: s,
          identityImg: s.identifyPoints.identityImg,
          userImg: s.userImg,
          falseArea: s.falseArea,
          describe: s.describe
        }
      })
    },
    date (isoString) {
      let date = new Date(isoString)
      return [[date.getFullYear(), date.getMonth() + 1, date.getDate()].join('/'), [date.getHours(), date.getMinutes()].join(':')].join(`     `).replace(/(?=\b\d\b)/g, '0')
    }
  }
}
</script>
<style lang="scss" scoped>

.order_export{
  font-size: 16px !important;
  // position: absolute;
  // top: -10000px;
  .ant-col{
    font-size: 14px;
  }
  ::v-deep .ant-table{
    font-size: 14px !important;
  }
}
::v-deep .ant-table-thead {
  .ant-table-row-cell-last{
    text-align: center;
  }
}
</style>
